<div
  class="modal fade"
  id="staticAnimationBackdrop"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticAnimationBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="dialogue-title">{{ this.dialogService.title }}</h4>
      </div>
      <div class="modal-body">
        <div class="img__container">
          @if (this.dialogService.isScannerVisible) {
            <img src="{{ SCAN_GIF }}" alt="coin animation" />
          }
        </div>
        <div id="dialogue-message">
          {{ this.dialogService.message }}
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn--close"
          id="btn-ok"
          data-dismiss="modal"
          (click)="this.dialogService.closeDialog()"
        >
          U redu
        </button>
      </div>
    </div>
  </div>
</div>
